/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module DnsModule
 */

import {
    IDnsQueryTypeMatch,
    MatchOperation,
} from 'generated-types';

import { DnsQueryTypeMatch } from 'object-types';
import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';
import { SchemaService } from 'ajs/modules/core/services/schema-service/schema.service';

/**
 * @description  DnsQueryTypeMatch ConfigItem class.
 * @author Abhinesh Gour
 */
export class DnsQueryTypeMatchConfigItem extends MessageItem<IDnsQueryTypeMatch> {
    public static ajsDependencies = [
        'schemaService',
    ];

    private readonly schemaService: SchemaService;

    constructor(args = {}) {
        super({
            objectType: DnsQueryTypeMatch,
            ...args,
        });

        this.schemaService = this.getAjsDependency_('schemaService');
    }

    /**
     * Convenience method to get text label for match criteria.
     */
    public get matchCriteria(): string {
        return this.schemaService.getEnumValueLabel(
            'MatchOperation',
            this.config.match_criteria,
        );
    }

    /**
     * Returns list of Query Types.
     */
    public get queryTypeList(): string[] {
        const { query_type: queryTypeEnumValueList = [] } = this.config;

        return queryTypeEnumValueList.map(
            (valueKey: string) => this.schemaService.getEnumValueLabel('DnsRecordType', valueKey),
        );
    }

    /** @override */
    // eslint-disable-next-line no-underscore-dangle
    public get defaultConfigOverride_(): Partial<IDnsQueryTypeMatch> {
        const defaultValues = this.getAjsDependency_('defaultValues');
        const defaultConfig = defaultValues.getDefaultItemConfigByType(this.objectType) || {};

        return {
            ...defaultConfig,
            match_criteria: MatchOperation.IS_IN,
        };
    }
}
